import { APP_DOWNLOAD } from '@/constants/urls';
import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';

interface ISendSMSProps {
  app: UserType;
  phone: string;
}

export enum UserType {
  owner = 'owner',
  renter = 'renter',
}

export const sendSMS = async (data: ISendSMSProps) => {
  await apiRequest(
    {
      url: `${getCoreApi()}${APP_DOWNLOAD}`,
      method: 'POST',
      data,
    },
    true,
    false,
  );
};
